import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Section } from '../../../a11y/headings/tagWrappers';
import Heading from '../../../a11y/headings/Heading';
import Timestamp from '../../../Timestamp';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import { getCoverImageAttributes } from '../../Thumb/helpers';
import { styleFromWidthHeight } from '../../_helpers';
import s from './Journal.scss';
var typeMap = {
    ANTFART: 'antfart',
    NANO: 'nano',
    MICRO: 'micro',
    TINY: 'tiny',
    SMALL: 'small',
    MEDIUM: 'medium',
    BIG: 'big',
};
var typeSizeMap = {
    ANTFART: 66,
    NANO: 150,
    MICRO: 170,
    TINY: 250,
    SMALL: 275,
    MEDIUM: 400,
    BIG: 600,
};
function getTypeBasedOnSize(size) {
    if (size <= typeSizeMap.ANTFART) {
        return typeMap.ANTFART;
    }
    if (size <= typeSizeMap.NANO) {
        return typeMap.NANO;
    }
    if (size <= typeSizeMap.MICRO) {
        return typeMap.MICRO;
    }
    if (size <= typeSizeMap.TINY) {
        return typeMap.TINY;
    }
    if (size >= typeSizeMap.BIG) {
        return typeMap.BIG;
    }
    if (size >= typeSizeMap.MEDIUM) {
        return typeMap.MEDIUM;
    }
    return typeMap.SMALL;
}
var JournalDumbView = function (_a) {
    var deviation = _a.deviation, className = _a.className, useTextlessMode = _a.useTextlessMode, width = _a.width, height = _a.height, _b = _a.responsive, responsive = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    // we need to show image background on full height for Micro and Nano thumbs
    var type = getTypeBasedOnSize(height || width);
    var isMicroOrNano = [typeMap.MICRO, typeMap.NANO].includes(type);
    var isWayTooTinyForAnySense = type === typeMap.ANTFART;
    var coverImageAttributes = getCoverImageAttributes({
        deviation: deviation,
        width: width,
        height: height,
    });
    var style = styleFromWidthHeight({ width: width, height: height }, responsive);
    var rootStyle = isMicroOrNano && coverImageAttributes
        ? __assign(__assign({}, style), coverImageAttributes.style) : style;
    var headerAttributes = !isMicroOrNano && !isWayTooTinyForAnySense ? coverImageAttributes : {};
    return (React.createElement(Section, { className: classnames(s['root'], s[type], useTextlessMode && s['default-bg'], className), style: rootStyle }, !useTextlessMode && (React.createElement(React.Fragment, null,
        React.createElement("div", __assign({ className: s['header'] }, headerAttributes),
            React.createElement(Heading, { className: s['title'] },
                !deviation.isPublished && (React.createElement("div", { className: s['draft'] }, t('writer.status.draft'))),
                deviation.title)),
        React.createElement("div", { className: s['body'] },
            React.createElement("div", { className: s['date'] },
                React.createElement(Timestamp, { timestamp: deviation.publishedTime })),
            React.createElement(ExcerptRenderer, { className: s['text'], textContent: deviation.textContent, htmlExcerptLegacy: true }))))));
};
JournalDumbView.displayName = 'JournalDumbView';
export default JournalDumbView;
//# sourceMappingURL=Journal.js.map